export default {"src":"/_next/static/media/circle_outlined_green.b3998963.svg","height":159,"width":159,"blurWidth":0,"blurHeight":0};